import { useState, useEffect, useCallback } from 'react';
import { getExploreVenueDetailV1 } from '@/services/platform/api/explore/explore';
import type { VenueDetailDto } from '@/services/platform/api/model';

export interface ExploreVenueDetailState {
  venue: VenueDetailDto | null;
  isLoading: boolean;
  refetch: () => void;
}

export function useExploreVenueDetail(venueNodeKey: string): ExploreVenueDetailState {
  const [venue, setVenue] = useState<VenueDetailDto | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(async () => {
    if (!venueNodeKey) return;
    setIsLoading(true);
    try {
      const response = await getExploreVenueDetailV1(venueNodeKey);
      if (response.status === 200) {
        setVenue(response.data);
      }
    } catch {
      // silent — caller checks venue === null
    } finally {
      setIsLoading(false);
    }
  }, [venueNodeKey]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { venue, isLoading, refetch: fetch };
}
